/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import { gql } from '@apollo/client';

const mutation = gql`
  mutation SaveSouscriptionPricingMutation($input: SaveSouscriptionPricing_M_souscription_pricingInput!) {
    saveSouscriptionPricing_M_souscription_pricing(input: $input) {
      ok
      error
      
    }
  }
`;

export default mutation;
